window.__wpcal_client_end = "user";

export default {
  __dummy_cliend_end: "user"
};
